export const ReleaseSnapshotsConfig = {
  getLatestReleaseSnapshots: '/recordstore/getLatestReleaseSnapshots?datasetId={:datasetId}&dataflowId={:dataflowId}',
  downloadSnapshot: '/recordstore/downloadSnapshot/{:datasetId}?dataflowId={:dataflowId}&fileName={:fileName}'
};
